import { useQuery } from "@tanstack/react-query";
import api from "../services/api/axios-client";

export const useAdminUsersQuery = () => {
  return useQuery({
    queryKey: ["adminUsers"],
    queryFn: () =>
      api
        .userControllerGetAdminUsers({ ignoreCache: false })
        .then((result) => result.data),
    staleTime: 60 * 60 * 1000, // 1 hour — matches backend cache
  });
};

export const useCurrentUserQuery = () => {
  return useQuery({
    queryKey: ["currentUser"],
    queryFn: () => api.userControllerGetMe().then((res) => res.data),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
